import { render, staticRenderFns } from "./ClearSolidIcon.vue?vue&type=template&id=45901243"
import script from "./ClearSolidIcon.vue?vue&type=script&lang=js"
export * from "./ClearSolidIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports